import { Instance } from 'mobx-state-tree';
import { ProofOfDeliveryPhotoDtoModelBase } from './ProofOfDeliveryPhotoDtoModel.base';

/* The TypeScript type of an instance of ProofOfDeliveryPhotoDtoModel */
export interface ProofOfDeliveryPhotoDtoModelType extends Instance<typeof ProofOfDeliveryPhotoDtoModel.Type> {}

/* A graphql query fragment builders for ProofOfDeliveryPhotoDtoModel */
export { selectFromProofOfDeliveryPhotoDto, proofOfDeliveryPhotoDtoModelPrimitives, ProofOfDeliveryPhotoDtoModelSelector } from './ProofOfDeliveryPhotoDtoModel.base';

/**
 * ProofOfDeliveryPhotoDtoModel
 */
export const ProofOfDeliveryPhotoDtoModel = ProofOfDeliveryPhotoDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
